import script from "./proceedorder.vue?vue&type=script&setup=true&lang=js"
export * from "./proceedorder.vue?vue&type=script&setup=true&lang=js"

import "./proceedorder.vue?vue&type=style&index=0&id=47cc3f6e&scoped=true&lang=css"

import exportComponent from "F:\\proj-abhinav\\meraki\\patient-portal-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47cc3f6e"]])

export default __exports__